<template>
  <div class="projects">
    <pageHeaderView></pageHeaderView>
    <Card class="content">
      <div class="card-header">
        <div class="card-header-text">全部项目列表</div>
        <div class="card-header-divider"></div>
      </div>
      <div class="box-header">
        <div class="box-tools">
          <div style="display: inline-block;margin-right:15px;" @mouseenter="toggleSearch(true)" @mouseleave="toggleSearch(false)">
            <Select v-model="searchBy" class="table-search" :class="{on: tableSearchOn||searchMode||searchBy}">
              <Option value="">不限</Option>
              <Option :value="col.searchKey?col.searchKey:col.key" v-for="col in columns.filter((c)=>{return c.title && c.searchable})" :key="col.key">{{col.title}}</Option>
            </Select>&nbsp;
            <Input v-model="keyword" ref="tableSearch" placeholder="搜索关键字" @on-focus="toggleSearchMode" @on-blur="toggleSearchMode" class="table-search" :class="{on: tableSearchOn||searchMode||keyword}"></Input>&nbsp;
            <Button type="default" icon="ios-search" @click="search"></Button>
          </div>
          <Button-group>
            <Button type="default" icon="md-add" @click="$router.push('/projects/new')">新增</Button>
            <Button type="default" icon="md-refresh" @click="refreshList">刷新</Button>
          </Button-group>
        </div>
      </div>
      <div class="box-body">
        <Table stripe :columns="columns" :data="dataViewPage" ref="table" @on-selection-change="selectRowChange"></Table>
        <div style="margin: 10px;overflow: hidden">
          <Button type="primary" size="large" @click="exportData" :disabled="!rowSelected"><Icon type="ios-download-outline"></Icon> 导出原始数据</Button>
          <div style="float: right;">
            <Page :total="data.length" :page-size-opts="[10,20,50,100]" @on-change="changePage" @on-page-size-change="changePageSize" :current="pageCurrent" show-sizer></Page>
          </div>
        </div>
        <Modal v-model="modalDelete" width="360">
          <p slot="header" style="color:#f60;text-align:center">
            <Icon type="information-circled"></Icon>
            <span>删除确认</span>
          </p>
          <div style="text-align:center">
            <p>是否继续删除？</p>
          </div>
          <div slot="footer">
            <Button type="error" size="large" long :loading="modal_loading" @click="del">删除</Button>
          </div>
        </Modal>
      </div>
    </Card>
    <router-view :data="projectSelected"></router-view>
  </div>
</template>

<script>
import pageHeaderView from '../public/PageHeader'
import cities from '../../assets/cities'
import leftPad from 'leftpad'

export default {
  name: 'projects',
  components: {
    pageHeaderView
  },
  data () {
    return {
      datatableData: [],
      loading: false,
      projectSelected: null,
      modal_loading: false,
      modalDelete: false,
      modalDisable: false,
      modalDetail: false,
      rowSelected: false,
      rowSelectedList: [],
      pageCurrent: 1,
      pageSize: 10,
      keyword: '',
      searchBy: '',
      searchMode: false,
      tableSearchOn: false,
      columns: [
        { type: 'selection', width: 60, align: 'center' },
        {
          title: '项目名称',
          key: 'Name',
          width: 400,
          ellipsis: true,
          sortable: true,
          searchable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '状态',
          key: 'Status',
          width: 80,
          ellipsis: true,
          filters: [
            {
              label: '计划',
              value: 0
            },
            {
              label: '在建',
              value: 1
            },
            {
              label: '竣工',
              value: 2
            },
            {
              label: '停工',
              value: 3
            }
          ],
          filterMultiple: true,
          filterMethod (value, row) {
            return row.Status === value
          },
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          },
          render: (h, params) => {
            return h('Tag', {
              props: {
                // type: 'dot',
                color: this.$common.projectStatusColor[params.row.Status.toString()]
              }
            }, this.$common.projectStatus[params.row.Status.toString()])
          }
        },
        {
          title: '项目所在地',
          key: 'Area',
          width: 180,
          sortable: true,
          searchable: true,
          render: (h, params) => {
            return h('span', null, this.getArea(params.row))
          }
        },
        {
          title: '项目地址',
          key: 'Address',
          width: 260,
          ellipsis: true,
          sortable: true,
          searchable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '计划开工日期',
          key: 'PlannedStartDate',
          width: 120,
          sortable: true,
          searchable: true,
          render: (h, params) => {
            return h('span', null, this.$moment(params.row.PlannedStartDate).format('YYYY-MM-DD'))
          }
        },
        {
          title: '计划竣工日期',
          key: 'PlannedCompletionDate',
          width: 120,
          sortable: true,
          searchable: true,
          render: (h, params) => {
            return h('span', null, this.$moment(params.row.PlannedCompletionDate).format('YYYY-MM-DD'))
          }
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 120,
          render: (h, params) => {
            return h('Button-group', [
              h('Button', {
                props: {
                  type: 'default',
                  size: 'small'
                },
                style: {
                },
                on: {
                  click: () => {
                    this.projectSelected = params.row
                    this.$router.push({ path: '/projects/view/' + params.row.Tid })
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  type: 'default',
                  size: 'small',
                  dataToggle: 'modal',
                  dataTarget: '#projectEdit'
                },
                style: {
                },
                on: {
                  click: () => {
                    this.projectSelected = params.row
                    this.$router.push({ path: '/projects/edit/' + params.row.Tid })
                  }
                }
              }, '修改')
            ])
          }
        }
      ],
      dataRaw: [],
      data: [],
      dataViewPage: []
    }
  },
  watch: {
    'data': function () {
      let vmInstance = this
      this.dataViewPage = this.data.filter(function (item, index) {
        return index < vmInstance.pageSize * vmInstance.pageCurrent && index >= vmInstance.pageSize * (vmInstance.pageCurrent - 1)
      })
      this.dataViewPage.forEach((item) => {
        item.Area = leftPad(item.Province, 2) + leftPad(item.Municipality, 2) + leftPad(item.County, 2)
      })
    },
    'pageCurrent': function () {
      let vmInstance = this
      this.dataViewPage = this.data.filter(function (item, index) {
        return index < vmInstance.pageSize * vmInstance.pageCurrent && index >= vmInstance.pageSize * (vmInstance.pageCurrent - 1)
      })
    },
    'pageSize': function () {
      let vmInstance = this
      this.dataViewPage = this.data.filter(function (item, index) {
        return index < vmInstance.pageSize
      })
    }
  },
  mounted () {
    this.$store.dispatch('setPageStore', {
      pageHeader: '项目列表',
      pageDescr: '全部项目列表'
    })
    this.initDataTable()
  },
  methods: {
    initDataTable () {
      this.$Spin.show()
      this.$Api.Project.listAllProjects().then((respBody) => {
        this.$Spin.hide()
        this.dataRaw = respBody.Projects.sort((a, b) => {
          return b.Tid - a.Tid
        })
        this.data = respBody.Projects.sort((a, b) => {
          return b.Tid - a.Tid
        })
        this.pageSize = 10
        this.pageCurrent = 1
      })
      .catch(err => {
        this.$Spin.hide()
        this.$Notice.error({
          title: '获取列表失败!',
          desc: err.message
        })
      })
    },
    getArea (row) {
      let county = this.getCityName(leftPad(row.Province, 2) + leftPad(row.Municipality, 2) + leftPad(row.County, 2))
      let municipality = this.getCityName(leftPad(row.Province, 2) + leftPad(row.Municipality, 2) + '00')
      let province = this.getCityName(leftPad(row.Province, 2) + '0000')
      return province + '/' + municipality + '/' + county
    },
    getCityName (code) {
      try {
        return cities.filter((item) => {
          return item.code === code
        })[0].city
      } catch (e) {
        return 'unkown'
      }
    },
    getProject (tid) {
      this.projectSelected = null
      this.projectSelected = this.datatableData.filter(function (item) {
        return item.Tid === tid
      })[0]
    },
    selectRowChange (selection) {
      if (selection.length > 0) {
        this.rowSelected = true
        this.rowSelectedList = selection
      } else {
        this.rowSelected = false
        this.rowSelectedList = []
      }
    },
    changePage (page) {
      this.pageCurrent = page
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
    },
    exportData () {
      this.$refs.table.exportCsv({
        filename: 'zztdata.csv',
        columns: this.columns,
        data: this.rowSelectedList
      })
    },
    del () {
      this.modal_loading = true
      setTimeout(() => {
        this.modal_loading = false
        this.modalDelete = false
        this.$Message.success('删除成功')
      }, 2000)
    },
    refreshList () {
      // refreshList()
      this.initDataTable()
      this.searchBy = ''
      this.keyword = ''
      this.searchMode = false
      this.tableSearchOn = false
    },
    toggleSearchMode () {
      this.searchMode = !this.searchMode
    },
    toggleSearch (val) {
      this.tableSearchOn = val
    },
    search () {
      let cols = this.columns.filter((col) => {
        return col.searchable
      })
      this.data = this.dataRaw.filter((item) => {
        if (this.searchBy) {
          let content = this.getSearchQueryContent(item, this.searchBy)
          return content.toString().indexOf(this.keyword) >= 0
        } else {
          let found = false
          for (let i = 0; i < cols.length; i++) {
            let col = cols[i]
            let content = this.getSearchQueryContent(item, col.searchKey ? col.searchKey : col.key)
            if (content && (content.toString().indexOf(this.keyword) >= 0)) {
              found = true
            }
          }
          return found
        }
      })
      this.pageCurrent = 0
      this.pageCurrent = 1
    },
    getSearchQueryContent (item, key) {
      if (!key) {
        return ''
      }
      let qArr = []
      let qArrTemp = key.split('.')
      qArrTemp.forEach((q) => {
        if (q.indexOf(']')) {
          let subArr = q.replace(/]/g, '').split('[')
          subArr.forEach((sub) => {
            qArr.push(sub)
          })
        } else {
          qArr.push(q)
        }
      })
      let content = item
      qArr.forEach((query) => {
        if (content[query]) {
          content = content[query]
        } else {
          content = ''
        }
      })
      return content
    }
  }
}
</script>

<style lang="less" scoped>
.content {}
</style>
